/* PULLEX store improvements — native cart events; no cart writes or polling. */
(() => {
  'use strict';
  if (window.PullexStoreUpgrade) return;
  let revision = 0;
  let controller;
  let timer;
  function renderCount(count) {
    if (!Number.isSafeInteger(count) || count < 0) return;
    document.querySelectorAll('[data-pullex-live-cart-count]').forEach(node => { node.textContent = String(count); });
    document.querySelectorAll('[data-pullex-cart-link]').forEach(link => { link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items')); });
  }
  function cartChanged(event) {
    const ticket = ++revision;
    clearTimeout(timer);
    controller?.abort();
    const count = event?.cartData?.item_count;
    if (Number.isSafeInteger(count) && count >= 0) { renderCount(count); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}, signal: controller.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (ticket === revision) renderCount(cart.item_count);
      } catch (_) { /* Keep the last server-rendered count if this read fails. */ }
    }, 60);
  }
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, cartChanged);
    window.addEventListener('pageshow', event => { if (event.persisted) cartChanged(); });
    const params = new URLSearchParams(location.search);
    const about = params.get('about');
    // This theme translates the field name (for example contact[Comment]); its ID stays stable.
    const field = document.querySelector('textarea#ContactForm-body') || document.querySelector('textarea[name="contact[body]"]');
    if (/\/pages\/contact\/?$/.test(location.pathname) && field && !field.value.trim() && about) {
      const item = (params.get('item') || '').slice(0, 80);
      field.value = 'Hi PULLEX, I have a question about ' + about.slice(0, 240) + (item ? ' (item ' + item + ')' : '') + ':\n\n';
    }
  }
  window.PullexStoreUpgrade = {refreshCart: cartChanged};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
